import { useState } from "react";
import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import { StringOrNumber } from "../../../library/helpers/StringOrNumber";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import CsmGenericTwoBoxListMultiSelectField from "../../../library/components/mui/twobox/CsmGenericTwoBoxListMultiSelectField";

interface ISortableMetaListPopupEditorProps<T, U extends StringOrNumber> {
    genelDurumHelper: GenelDurumHelper,
    itemLabel: string,
    label: string
    value: U[],
    availableList: T[],
    wholeList?: T[],
    labelGetter: (item: T) => string,
    valueGetter: (item: T) => U,
    closer: (result: U[] | null) => void,
}

function SortableMetaListPopupEditor<T, U extends StringOrNumber>(props: ISortableMetaListPopupEditorProps<T, U>) {
    const { closer, itemLabel, label, value, wholeList, availableList, labelGetter, valueGetter, genelDurumHelper } = props;

    const [currentData, setCurrentData] = useState<U[]>(value.slice());

    return (
        <Rows pt={20}>
            <Rows>
                <CsmGenericTwoBoxListMultiSelectField
                    itemLabel={itemLabel}
                    label={label}
                    value={currentData}
                    onChange={(e) => setCurrentData(e)}
                    availableList={availableList}
                    wholeList={wholeList}
                    labelGetter={labelGetter}
                    valueGetter={valueGetter}
                    sortable
                    labels={{
                        secilmeyenler: genelDurumHelper.translate("Seçilmeyenler"),
                        secilenler: genelDurumHelper.translate("Seçilenler"),
                        listeyeEklemekIcinTıklayabilirsiniz: genelDurumHelper.translate("Listeye eklemek için tıklayabilirsiniz"),
                        siralarınıDegistirmekIcinTasiyabilirsinizListedenCikartmakIcinTiklayabilirsiniz: genelDurumHelper.translate("Sıralarını değiştirmek için taşıyabilirsiniz. Listeden çıkartmak için tıklayabilirsiniz"),
                    }}
                />
            </Rows>
            <Columns height={60} mt={10}>
                <Button color="error" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.iptal}
                    {genelDurumHelper.translate("İptal")}</Button>
                <Button color="success" variant="contained" onClick={() => closer(currentData)} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Kaydet")}</Button>
            </Columns>
        </Rows>
    );

}

export default SortableMetaListPopupEditor;